import { PostingDistanceDTO, PostingDTO } from './dto/PostingDTO';

// Loads along route flag, pickup_distance and delivery_distance are not available in Load details API but in Load List API
// We will reuse the data from Load List API
const postingCacheMap = new Map<
  string,
  {
    is_search_along_route: boolean;
    pickup_distance: PostingDistanceDTO | null;
    delivery_distance: PostingDistanceDTO | null;
  }
>();

export function setPostingCache(posting: PostingDTO) {
  postingCacheMap.set(posting.load.guid, {
    is_search_along_route: !!posting.load.is_search_along_route,
    pickup_distance: posting.pickup_distance,
    delivery_distance: posting.delivery_distance,
  });
}

function getPostingCache(postingGuid: string) {
  const cache = postingCacheMap.get(postingGuid);
  return {
    is_search_along_route: !!cache?.is_search_along_route,
    pickup_distance: cache?.pickup_distance ?? null,
    delivery_distance: cache?.delivery_distance ?? null,
  };
}

export function clearPostingCache() {
  postingCacheMap.clear();
}

export function populatePostingFromCache(posting: PostingDTO) {
  const postingCache = getPostingCache(posting.load.guid);
  posting.load.is_search_along_route = postingCache.is_search_along_route;
  posting.pickup_distance = postingCache.pickup_distance;
  posting.delivery_distance = postingCache.delivery_distance;
  return posting;
}
